module.exports = __webpack_public_path__ + "static/media/ZTDC02.6f009b2a.jpg";